import { GoogleAnalytics } from '@framework/browser/analytics/google';

class ResearchGATrack {
  static documentClick(params: {
    link: string,
    research_name: string,
    sector: string,
    subsector: string,
    publisher: string,
    publish_date: string,
    type: string,
  }): void {
    GoogleAnalytics.track('abs_research', params);
  }
}

export default ResearchGATrack;
